import { render, staticRenderFns } from "./TogglePedido.vue?vue&type=template&id=653a7c7e"
import script from "./TogglePedido.vue?vue&type=script&lang=js"
export * from "./TogglePedido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports